<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.qu_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="qu_custname">
            <label class="weui-form-preview__label">{{customLabel.qu_custname || "客户名称"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.qu_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="qu_contact">
            <label class="weui-form-preview__label">{{customLabel.qu_contact || "联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.qu_contact }} {{ form.main.qu_tel }}
              <call-mobile :mobile="form.main.qu_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="qu_date">
            <label class="weui-form-preview__label">{{customLabel.qu_date || "发布日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.qu_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qu_enddate">
            <label class="weui-form-preview__label">{{customLabel.qu_enddate || "截止日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.qu_enddate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qu_seller">
            <label class="weui-form-preview__label">{{customLabel.qu_seller || "业务员"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qu_seller
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qu_payments">
            <label class="weui-form-preview__label">{{customLabel.qu_payments || "收款方式"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qu_payments
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qu_businesscode">
            <label class="weui-form-preview__label">{{customLabel.qu_businesscode || "商机编号"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.qu_businesscode
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="qu_currency">
            <label class="weui-form-preview__label">{{customLabel.qu_currency || "币种"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.qu_currency
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="qu_taxrate">
            <label class="weui-form-preview__label">{{customLabel.qu_taxrate || "税率"}}</label>
            <em class="weui-form-preview__value">{{ form.main.qu_taxrate }}</em>
          </div>
         
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.qd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="qd_prodName">
              <label class="weui-form-preview__label">{{customLabel.qd_prodName || "物料名称"}}</label>
              <span class="weui-form-preview__value">{{
                item.qd_prodName
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.qd_prodOriSpec" slot="qd_prodOriSpec">
              <label class="weui-form-preview__label">{{customLabel.qd_prodOriSpec || "型号"}}</label>
              <span class="weui-form-preview__value">{{
                item.qd_prodOriSpec
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.qd_prodSpec" slot="qd_prodSpec">
              <label class="weui-form-preview__label">{{customLabel.qd_prodSpec || "规格"}}</label>
              <span class="weui-form-preview__value">{{
                item.qd_prodSpec
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.qd_qty" slot="qd_qty">
              <label class="weui-form-preview__label">{{customLabel.qd_qty || "数量"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.qd_qty }} {{ item.qd_prodUnit }}</span
              >
            </div>
            <div class="weui-form-preview__item" v-if="item.qd_zxbzs" slot="qd_zxbzs">
              <label class="weui-form-preview__label">{{customLabel.qd_zxbzs || "最小包装量"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.qd_zxbzs }} {{ item.qd_prodUnit }}</span
              >
            </div>
            <div class="weui-form-preview__item" v-if="item.qd_zxdgs" slot="qd_zxdgs">
              <label class="weui-form-preview__label">{{customLabel.qd_zxdgs || "最小订购量"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.qd_zxdgs }} {{ item.qd_prodUnit }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="showData">
              <label class="weui-form-preview__label">{{customLabel.showData || "单价"}}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon keep-spaces"
              >
                {{ getPriceDesc(item) }}
              
              </span>
            </div>
            <div class="weui-form-preview__item" slot="qd_deliveryday">
              <label class="weui-form-preview__label">{{customLabel.qd_deliveryday || "交期天数"}}</label>
              <span class="weui-form-preview__value">{{
                item.qd_deliveryday
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.qd_delivery" slot="qd_delivery">
              <label class="weui-form-preview__label">{{customLabel.qd_delivery || "需求日期"}}</label>
              <span class="weui-form-preview__value">{{
                item.qd_delivery
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="qd_prodBrand">
              <label class="weui-form-preview__label">{{customLabel.qd_prodBrand || "厂家/品牌"}}</label>
              <span class="weui-form-preview__value">{{
                item.qd_prodBrand
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="qd_remark">
              <label class="weui-form-preview__label">{{customLabel.qd_remark || "备注"}}</label>
              <span class="weui-form-preview__value">{{ item.qd_remark }}</span>
            </div>
            <div
              class="weui-form-preview__item" slot="pr_saleprice"
              v-if="item.productDTO && item.productDTO.pr_saleprice"
            >
              <label class="weui-form-preview__label">{{customLabel.pr_saleprice || "最近售价(元)"}}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.productDTO.pr_saleprice,'#,##0.####')
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.main.qu_remark">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.qu_remark
            }}</span>
          </div>
        </div>
      </div>
      <file-list v-model="form.main.qu_attach" />
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/sale/quote_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑报价</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/sale/quotation",
      codeField: "qu_code",
      statusField: "qu_statuscode",
      caller: "Quotation",
      xtype: "sale-quotation-formpanel",
    };
  },
  methods: {
    getPriceDesc(item) {
      var list = item.gradientPriceDTOList;
      if (list) {
        return list.map((i) => i.gp_step + "+    ¥" + i.gp_price).join("\n");
      }
      return null;
    },
  },
};
</script>

<style scoped>
.keep-spaces {
  white-space: pre; /* 保留所有空格和换行 */
}
</style>